import React,{ useState } from "react";


function NewGroup  ({showNewDialog,saveGroup,hideNewGroupDialogs}){

    //const [showDialog,setVisibility] = useState(true);
    const [group,setGroup] = useState({groupname:"",responsible: "",responsiblePhone: ""});
    let groupToCreate = group;

    if(showNewDialog)
    return (<><div style={{zIndex:9998, backgroundColor:"rgb(172 204 146)", position: "absolute", left:"0px",right:"0px",bottom:"0px",top:"0px", opacity:0.8}}>  </div><div style={{zIndex:9999,position:"fixed",left: "2pt", maxWidth: "400pt", top: 20 + "%",height:"200pt", backgroundColor: "#96c56f",padding:"5px", border: "1px solid", borderRadius:"5px"}}>
          <div style={{display:"inline-block", width: "100%"}}>
            <h1>Uusi ryhmä</h1>
            <div style={{float:"left"}}>Ryhmännimi</div><div style={{float:"right",width:"200pt"}}><input
            type="text"
            value={groupToCreate.groupname}
            onChange={(e) => {setGroup({...groupToCreate,groupname: e.target.value}); }}
            style={{ marginRight: "0.5em",  marginLeft: "0.5em", width: "100%" }}
          /></div>
          </div>
          <div style={{display:"inline-block", width: "100%"}}>
            <div style={{float:"left"}}>Vastuuhenkilö</div><div style={{float:"right",width:"200pt"}}><input
            type="text"
            value={groupToCreate.responsible}
            onChange={(e) => {setGroup({...groupToCreate,responsible: e.target.value}); }}
            style={{ marginRight: "0.5em",  marginLeft: "0.5em", width: "100%"}}
          /></div>
          
          </div>
          
          <div style={{display:"inline-block", width: "100%"}}>
            <div style={{float:"left"}}>Vastuuhenkilö puh</div><div style={{float:"right",width:"200pt"}}><input
            type="text"
            value={groupToCreate.responsiblePhone}
            onChange={(e) => {setGroup({...groupToCreate,responsiblePhone: e.target.value}); }}
            style={{ marginRight: "0.5em",  marginLeft: "0.5em", width: "100%" }}
          /></div>
            </div>
            <div style={{display:"inline-block", width: "100%", paddingTop: "10pt"}}>
            <div style={{clear: "both"}}><button style={{width:"100px",height:"30px"}} onClick={() => {saveGroup(groupToCreate);hideNewGroupDialogs();setGroup({groupname:"",responsible: "",responsiblePhone: ""})}}>Tallenna</button> <button style={{marginLeft:"20px",width:"100px",height:"30px"}} onClick={() => hideNewGroupDialogs()}>Sulje</button></div>
            
           
        </div>
        </div>
        </>
    )
    else
    return(<></>)

}

export default NewGroup;